import type { VariantProps } from 'class-variance-authority'
import type { AppConfig } from 'nuxt/schema'
import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export function buttonVariants(appConfig: AppConfig) {
  return cva(appConfig.ui.button.slots.base, {
    variants: appConfig.ui.button.variants,
    defaultVariants: { ...appConfig.ui.button.defaultVariants },
  })
}

export type ButtonVariants = VariantProps<ReturnType<typeof buttonVariants>>
